import React from 'react';
import PropTypes from 'prop-types';

import IMAGES from '../../assets/images';
import JobSheetLabelFields from './JobSheetLabelFields';
import JobSheetLabelSideForm from './JobSheetLabelSideForm';
import helpers from '../../helpers';

const sx = {
    // label root
    root: (preview) => ({
        margin: '0', backgroundColor: 'white', display: 'flex', width: '11in', height: preview ? '8.5in' : '11in',
        ...preview
            ? { scale: '0.5', marginTop: '-13rem', marginBottom: '-13rem', border: '1px solid black' }
            : { transformOrigin: '0in 4.25in', transform: 'rotate(90deg) translateX(-4.25in) translateY(-4.25in)' }
    }),

    // left container
    leftContainer: { margin: '0', float: 'left', width: '10in', height: '8.5in', display: 'flex', flexDirection: 'column' },
    header: { width: '100%', height: '0.4in', display: 'block' },
    headerLogo: { width: '1.5in', float: 'left', marginLeft: '10px', marginTop: '0.1in', marginBottom: 'auto', maxHeight: '0.2in' },
    areaLabelContainer: { width: '8in', float: 'right', marginRight: '5px', marginTop: '0.1in', marginBottom: 'auto', maxHeight: '0.3in', fontSize: '17px', paddingLeft: '5px', paddingRight: '5px', textTransform: 'uppercase', whiteSpace: 'nowrap', textAlign: 'right', overflow: 'hidden' },
    areaValueLabel: { fontWeight: 'bold' },
    areaTypeLabel: { fontStyle: 'italic' },
    imgContainer: { width: '10in', height: '6.90in' },
    colorBand: { width: '11in', height: '0.15in', textAlign: 'center', fontSize: '15px', fontWeight: 'medium' },
    footer: { display: 'grid', gridTemplateColumns: '0.5fr 1.25fr 1.25fr', width: '11in', height: '0.25in' },
    inspectionGrid: { textAlign: 'center', border: '1px solid black', display: 'flex', flexDirection: 'column', height: '100%' },

    // right container
    rightContainer: { margin: '0', float: 'left', width: '1.5in', height: '4in', borderBottom: '1px solid lightgray' },
    sideForm: { width: '100%', height: '100%' }
};

const JobSheetLabel = ({ image, job, template, filter, areaName, colorBand, checklist, part, hashId, areaType = 'parts', preview = false, areaPartsLength = 0 }) => {

    const fields = helpers.parser.getValues(job, template, filter);

    return (
        <div style={sx.root(preview)}>

            <div style={sx.leftContainer}>

                {/* Label Header */}
                <div style={sx.header}>
                    <img style={sx.headerLogo} src={IMAGES.logos.SPEEDlabel} />
                    <div style={{ ...sx.areaLabelContainer }}>
                        {areaName.map(({ areaKeyLabel, areaValueLabel }, idx) => (
                            <span key={idx}>
                                <span>{areaKeyLabel}</span>: <span style={sx.areaValueLabel}>{areaValueLabel}</span>&nbsp;
                            </span>
                        ))}
                        {areaPartsLength > 0 && (<span>| Parts: <span style={sx.areaValueLabel}>{areaPartsLength}</span>&nbsp;</span>)}
                        | <span style={sx.areaTypeLabel}>{areaType}</span>&nbsp;
                    </div>
                </div>

                {/* Label Image Container */}
                <div style={sx.imgContainer}>
                    {image}
                </div>

                {/* Label Color Band */}
                <div style={sx.colorBand}>
                    {colorBand.map(({ label, style }) => (<div key={label} style={{ ...style, fontWeight: 'bold' }}>{label}</div>))}
                </div>

                {/* Label Fields */}
                <JobSheetLabelFields fields={fields} />

                {/* Label Inspected By */}
                <div style={sx.footer}>
                    <div style={sx.inspectionGrid}>Inspected By:</div>
                    <div style={sx.inspectionGrid} />
                    <div style={sx.inspectionGrid} />
                </div>
            </div>

            <div style={sx.rightContainer}>

                <div style={sx.sideForm}>
                    <JobSheetLabelSideForm checklist={checklist} part={part} hashId={hashId} />
                </div>
            </div>

        </div>
    );
};

JobSheetLabel.propTypes = {
    image: PropTypes.object,
    job: PropTypes.object,
    template: PropTypes.object,
    filter: PropTypes.object,
    areaName: PropTypes.array,
    colorBand: PropTypes.array,
    checklist: PropTypes.object,
    part: PropTypes.object,
    hashId: PropTypes.string,
    areaType: PropTypes.string,
    preview: PropTypes.bool,
    areaPartsLength: PropTypes.number
};

export default JobSheetLabel;